module.exports = __webpack_public_path__ + "img/item_img2.93d24f1f.png";